document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.blog-archive__load-more');
  if (!btn) return;

  const list = document.querySelector('.blog-archive__list');
  if (!list) return;

  btn.addEventListener('click', async () => {
    const paged    = parseInt(btn.dataset.paged, 10);
    const perPage  = parseInt(btn.dataset.perPage, 10);
    const maxPages = parseInt(btn.dataset.maxPages, 10);
    const nonce    = btn.dataset.nonce;
    const context  = btn.dataset.context || '{"type":"blog"}';

    if (![paged, perPage, maxPages].every(Number.isInteger) || !nonce) {
      console.error('Load more is missing required configuration.');
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Loading…';
    btn.setAttribute('aria-busy', 'true');

    const body = new URLSearchParams({
      action:   'blog_load_more',
      nonce,
      paged,
      per_page: perPage,
      context,
    });

    try {
      const res  = await fetch(wfpAjax.ajaxUrl, { method: 'POST', body });
      const html = await res.text();

      if (!res.ok || html.trim() === '-1') {
        throw new Error(`Load more request failed with status ${res.status}.`);
      }

      if (!html.trim()) {
        btn.remove();
        return;
      }

      list.insertAdjacentHTML('beforeend', html);

      if (paged >= maxPages) {
        btn.remove();
      } else {
        btn.dataset.paged = paged + 1;
      }
    } catch (err) {
      console.error('Load more failed', err);
    } finally {
      if (btn.isConnected) {
        btn.disabled = false;
        btn.textContent = 'Load More';
        btn.removeAttribute('aria-busy');
      }
    }
  });
});
